<template>
  <v-dialog v-model="dialogVisivel" persistent max-width="800">
    <v-card class="not-margin pt-0 pr-0 pl-0">
      <v-toolbar dark color="primary">
        <div class="text-center">
          <v-icon>mdi-school</v-icon>
          Confirmação de Presença em Formação
        </div>
      </v-toolbar>
        <div class="container dialog">
            <v-form ref="form">
            <v-row class="mt-5">
                <v-col cols="12">
                <v-text-field :value="formacaoAtual.nome" label="Formação" readonly outlined dense />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="6">
                <v-text-field :value="formacaoAtual.cargaHoraria" label="Carga Horária" readonly outlined dense />
                </v-col>
                <v-col cols="6">
                <v-text-field :value="formacaoAtual.dataRealizacao" label="Data de Realização" readonly outlined dense />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                <v-text-field :value="formacaoAtual.localRealizacao" label="Local de Realização" readonly outlined dense />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                <div class="mb-2 font-weight-medium">Instrutor(es)</div>
                <v-chip-group column>
                    <v-chip
                    v-for="(instrutor, index) in formacaoAtual.instrutores"
                    :key="index"
                    color="primary"
                    dark
                    >
                    {{ instrutor }}
                    </v-chip>
                </v-chip-group>
                </v-col>
            </v-row>
            <v-container class="px-0" fluid>
                <v-checkbox v-model="checkbox">
                    <template v-slot:label>
                    <span>
                        Eu <strong>{{ $user.fullName }}</strong>, CPF <strong>{{ $formatCpf($user.username) }}</strong>, declaro, sob minha responsabilidade, que a confirmação de presença nesta formação foi realizada de forma consciente e verdadeira, estando plenamente ciente das implicações decorrentes desta declaração.
                    </span>
                    </template>
                </v-checkbox>
            </v-container>
            <sigfoco-buttons
                :actionText="'Confirmar Presença'"
                :cancelText="'Confirmar Ausência'"
                @click="confirmarPresenca(true)"
                @cancel="confirmarPresenca(false)"
            />
            </v-form>
        </div>
    </v-card>
  </v-dialog>
</template>

<script>
import ListaDePresencaService from '~/services/manter-lista-presenca.service';
import { AUTH_NAMESPACE, USER, LOGIN } from 'store/modules/auth';
export default {
    name: 'ConfirmarFormacaoDialog',
    mixins: [ListaDePresencaService],
    props: {
        dialogVisivel: Boolean,
        formacoes: Array,
        usuario: Object
        },
        data() {
        return {
            checkbox: false,
            indexAtual: 0
        };
        },
    computed: {
        user() {
            return this.$store.getters[`${AUTH_NAMESPACE}/${USER}/${LOGIN}`];
        },
        formacaoAtual() {
            return this.formacoes[this.indexAtual];
        }
    },
  methods: {
    refreshTokenUi() {
        this.$renovarToken().then(({ data }) => {
          if (data.sucesso) {
            return this[LOGIN](data);
          }
        })
    },
    confirmarPresenca(presente) {
        if (!this.checkbox) {
            return this.$notifyWarning('Por favor, marque o checkbox de confirmação de participação.');
        }

        this.$swal({
            text: "Deseja confirmar essa operação?",
            type: "warning",
            showCancelButton: true,
            confirmButtonText: "Confirmar",
            cancelButtonText: "Cancelar"
        }).then(result => {
            if (result) {
            const formacaoId = this.formacaoAtual.id;
            const payload = { presente, formacaoId };

            this.$marcarPresenca(formacaoId, payload).then(({ data }) => {
                this.$notifySuccess(data?.mensagem);
                this.checkbox = false;

                if (this.indexAtual < this.formacoes.length - 1) {
                this.indexAtual++;
                } else {
                this.refreshTokenUi().then(() => this.$emit('onClose'));
                }
            });
            }
        });
    }
  }
};
</script>

<style scoped>
.v-chip {
  margin: 4px;
}
</style>
